import { TextField } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import { CONTRACTS_MODAL_STYLES } from "../../styles/styles";

export default function ContractsDateField({ fieldName, fieldValue, onChange }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        className="w-full"
        value={fieldValue}
        onChange={(newValue) => onChange(fieldName, newValue)}
        slotProps={{
          textField: { size: "small", sx: CONTRACTS_MODAL_STYLES.datePickerTextField },
          openPickerButton: { sx: { marginRight: "2px" } },
        }}
        renderInput={(params) => <TextField {...params} />}
      />
    </LocalizationProvider>
  );
}
